import InformationIcon from '@/assets/icons/information.svg?react';
import ErrorIcon from '@/assets/icons/red-error.svg?react';
import {TrRevision} from '@/domain/models/TrRevision';
import {rtRevisions} from '@/entities/app/api/rtRevisions';
import {notificationStore} from '@/entities/notification';
import {APP_NAME} from '@/shared/consts/app';
import {getLanguageByLocalizationCode} from '@/shared/lib/appLanguageSupports';
import {
  getTmsOverrides,
  removeTmsOverrides,
  setTmsOverrides,
} from '@/shared/lib/localStorage/i18n/tmsOverrides';
import {getExternalUuid} from '@/shared/lib/localStorage/internalAnalytics';
import {
  getLanguage,
  init as i18nInit,
  setLanguage,
} from '@/shared/services/i18n';

type Translates = Record<string, string>;

export async function trRevisionHandler(trRevision?: TrRevision) {
  const tmsOverrides = getTmsOverrides();

  if (!trRevision) {
    if (tmsOverrides) {
      removeTmsOverrides();
    }

    return;
  }

  if (
    trRevision.hash === tmsOverrides?.hash &&
    trRevision.uuid === tmsOverrides?.uuid
  ) {
    return;
  }

  const {lang, keys} = await rtRevisions({
    initUuid: getExternalUuid(),
    uuid: trRevision.uuid,
  });

  const generalTranslates: Translates = {};
  const appTranslates: Translates = {};
  const webTranslates: Translates = {};

  const specificAppPrefix = `apps/${APP_NAME.toLowerCase()}/`;
  const specificWebPrefix = `web/`;
  for (const key in keys) {
    if (key.startsWith(specificAppPrefix)) {
      const adaptedKey = key.replace(specificAppPrefix, '');
      appTranslates[adaptedKey] = keys[key];
      continue;
    }

    if (key.startsWith(specificWebPrefix)) {
      const adaptedKey = key.replace(specificWebPrefix, '');
      webTranslates[adaptedKey] = keys[key];
      continue;
    }

    generalTranslates[key] = keys[key];
  }

  const normalizedLanguage = getLanguageByLocalizationCode(lang);

  if (!normalizedLanguage) {
    notificationStore.addNotification({
      message: `Unsupported language ${lang} provided by TMS`,
      Icon: ErrorIcon,
    });

    return;
  }

  setTmsOverrides({
    hash: trRevision.hash,
    translates: {
      ...generalTranslates,
      ...appTranslates,
      ...webTranslates,
    },
    lang: normalizedLanguage,
    uuid: trRevision.uuid,
  });

  notificationStore.addNotification({
    message: `The ${normalizedLanguage} translations have been replaced with a version from TMS`,
    Icon: InformationIcon,
  });

  if (getLanguage() !== normalizedLanguage) {
    notificationStore.addNotification({
      message: `Language switched to ${normalizedLanguage}`,
      Icon: InformationIcon,
    });
    await setLanguage(normalizedLanguage);
  }

  await i18nInit();
}
